export default __webpack_public_path__ + "static/media/root-background.30206bf8.jpg";